<template>
  <div class="describe">
    <div class="column_1">
      <strong :listTitle="listTitle">{{listTitle}}</strong>
    </div>
    <div class="pro_1" :content="content" v-html="content">{{content}}</div>
  </div>
</template>

<script>
export default {
  name: 'Describe',
  props: {
    listTitle: {
      type: String,
      default () {
        return ''
      }
    },
    content: {
      type: String,
      default () {
        return ''
      }
    }
  }
}
</script>

<style scoped>
  .describe {
    background: #FFFFFF;
    padding: 0 20px 0 20px;
  }
  .column_1 {
    padding-top: 40px;
    padding-bottom: 10px;
    height: 24px;
    line-height: 24px;
    font-size: 16px;
    text-align: center;
  }
  .pro_1 {
    padding: 25px 0px;
  }
</style>
